export const perPage = function (state, getters) {
  return state.perPage
}

export const currentUser = function (state, getters) {
  return state.currentUser
}

export const currentCompany = function (state, getters) {
  return state.currentCompany
}

export const qualityUpperLimit = function (state, getters) {
  return state.qualityUpperLimit
}

export const qualityLowerLimit = function (state, getters) {
  return state.qualityLowerLimit
}

export const statuses = function (state, getters) {
  return state.statuses
}

export const workOrderStatus = function (state, getters) {
  return state.workOrderStatus
}

export const picklistStatus = function (state, getters) {
  return state.picklistStatus
}

export const picklistUnits = function (state, getters) {
  return state.picklistUnits
}

export const selectedFlataRows = function (state, getters) {
  return state.selectedFlataRows
}

export const selectedFlata = function (state, getters) {
  return state.selectedFlata
}

export const workOrderUnit = function (state, getters) {
  return state.workOrderUnit
}

export const workOrderResponsible = function (state, getters) {
  return state.workOrderResponsible
}

export const responsibleSeller = function (state, getters) {
  return state.responsibleSeller
}

export const currentCompanyName = function (state, getters) {
  var cc = state.currentUser.companies.filter(function (x) {
    if (x.id === state.currentCompany) {
      return x
    }
  })
  return cc[0].name
}

export const apiUrl = function (state, getters) {
  return state.apiUrl
}

export const currentReport = function (state, getters) {
  return state.currentReports
}

export const currentReportName = function (state, getters) {
  return state.currentReportName
}

export const selectedReportRows = function (state, getters) {
  return state.selectedReportRows
}

export const currentCompanySelectedReportRows = function (state, getters) {
  return state.selectedReportRows[state.currentCompany]
}

export const currentCompanyReport = function (state, getters) {
  return state.currentReports[state.currentCompany]
}

export const routeData = function (state, getters) {
  return state.routeData
}

export const nodeEnv = function (state, getters) {
  return state.nodeEnv
}



// WEBPACK FOOTER //
// ./src/store/getters.js